import { render, staticRenderFns } from "./PlanningGame.vue?vue&type=template&id=1ca97baf&"
import script from "./PlanningGame.vue?vue&type=script&lang=js&"
export * from "./PlanningGame.vue?vue&type=script&lang=js&"
import style0 from "./PlanningGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports